import { AutopilotStep } from "./types";

export const THINKING_LABEL_KEYS = [
  "media.autopilot.thinkingLabels.thinking",
  "media.autopilot.thinkingLabels.analyzing",
  "media.autopilot.thinkingLabels.processing",
  "media.autopilot.thinkingLabels.understanding",
  "media.autopilot.thinkingLabels.reasoning",
  "media.autopilot.thinkingLabels.cogitating",
  "media.autopilot.thinkingLabels.meditating",
  "media.autopilot.thinkingLabels.contemplating",
  "media.autopilot.thinkingLabels.ruminating",
  "media.autopilot.thinkingLabels.deliberating",
  "media.autopilot.thinkingLabels.pondering",
  "media.autopilot.thinkingLabels.ideating",
  "media.autopilot.thinkingLabels.deducing",
  "media.autopilot.thinkingLabels.inferring",
  "media.autopilot.thinkingLabels.synthesizing",
  "media.autopilot.thinkingLabels.rationalizing",
  "media.autopilot.thinkingLabels.extrapolating",
  "media.autopilot.thinkingLabels.evaluating",
  "media.autopilot.thinkingLabels.assimilating",
  "media.autopilot.thinkingLabels.encoding",
  "media.autopilot.thinkingLabels.parsing",
  "media.autopilot.thinkingLabels.integrating",
  "media.autopilot.thinkingLabels.decoding",
  "media.autopilot.thinkingLabels.distilling",
  "media.autopilot.thinkingLabels.comprehending",
  "media.autopilot.thinkingLabels.apprehending",
  "media.autopilot.thinkingLabels.discerning",
  "media.autopilot.thinkingLabels.fathoming",
  "media.autopilot.thinkingLabels.grasping",
  "media.autopilot.thinkingLabels.perceiving",
  "media.autopilot.thinkingLabels.conceptualizing",
];

// readyWhen: data signal that gates early completion (after MIN_STEP_DISPLAY_MS).
// Steps without readyWhen either complete via their own onComplete callbacks
// (thinking-process, visuals, voiceover, scenes) or use only the min display time
// (templates — decorative, no data dependency). Final step has its own isPublished logic.
export const AUTOPILOT_STEPS_V2: AutopilotStep[] = [
  {
    id: 1,
    labelKey: "media.autopilot.steps.thinkingProcess.label",
    shortDescKey: "media.autopilot.steps.thinkingProcess.shortDesc",
    longDescKey: "media.autopilot.steps.thinkingProcess.longDesc",
    delayMs: 5000,
    type: "thinking-process",
  },
  {
    id: 2,
    labelKey: "media.autopilot.steps.objectiveCards.label",
    shortDescKey: "media.autopilot.steps.objectiveCards.shortDesc",
    longDescKey: "media.autopilot.steps.objectiveCards.longDesc",
    delayMs: 20000,
    type: "objective-cards",
    readyWhen: "objectivesReady",
  },
  // TODO: Requires backend support — commented out until available
  // {
  //   id: 3,
  //   labelKey: "media.autopilot.steps.audience.label",
  //   shortDescKey: "media.autopilot.steps.audience.shortDesc",
  //   longDescKey: "media.autopilot.steps.audience.longDesc",
  //   delayMs: 5000,
  //   type: "audience",
  // },
  {
    id: 4,
    labelKey: "media.autopilot.steps.palette.label",
    shortDescKey: "media.autopilot.steps.palette.shortDesc",
    longDescKey: "media.autopilot.steps.palette.longDesc",
    delayMs: 15000,
    type: "palette",
    readyWhen: "sectionsReady",
  },
  {
    id: 5,
    labelKey: "media.autopilot.steps.script.label",
    shortDescKey: "media.autopilot.steps.script.shortDesc",
    longDescKey: "media.autopilot.steps.script.longDesc",
    delayMs: 30000,
    type: "script",
    readyWhen: "templatesReady",
  },
  {
    id: 6,
    labelKey: "media.autopilot.steps.templates.label",
    shortDescKey: "media.autopilot.steps.templates.shortDesc",
    longDescKey: "media.autopilot.steps.templates.longDesc",
    delayMs: 12000,
    type: "templates",
  },
  {
    id: 7,
    labelKey: "media.autopilot.steps.visuals.label",
    shortDescKey: "media.autopilot.steps.visuals.shortDesc",
    longDescKey: "media.autopilot.steps.visuals.longDesc",
    delayMs: 20000,
    type: "visuals",
  },
  {
    id: 8,
    labelKey: "media.autopilot.steps.voiceover.label",
    shortDescKey: "media.autopilot.steps.voiceover.shortDesc",
    longDescKey: "media.autopilot.steps.voiceover.longDesc",
    delayMs: 28000,
    type: "voiceover",
  },
  {
    id: 9,
    labelKey: "media.autopilot.steps.scenes.label",
    shortDescKey: "media.autopilot.steps.scenes.shortDesc",
    longDescKey: "media.autopilot.steps.scenes.longDesc",
    delayMs: 8000,
    type: "scenes",
  },
  {
    id: 10,
    labelKey: "media.autopilot.steps.final.label",
    shortDescKey: "media.autopilot.steps.final.shortDesc",
    delayMs: 15000,
    type: "final",
  },
];

export const AUDIENCE_TAG_KEYS = [
  { labelKey: "media.autopilot.audienceTags.productManagers", icon: "💼" },
  { labelKey: "media.autopilot.audienceTags.teamLeads", icon: "👥" },
  { labelKey: "media.autopilot.audienceTags.founders", icon: "🚀" },
  { labelKey: "media.autopilot.audienceTags.strategists", icon: "🎯" },
];
